<template>
  <b-modal class="fade" id="view-available-codes-modal" ref="modal" size="sm" centered scrollable
    dialog-class="base-modal" body-class="px-md-4" footer-class="justify-content-center" @show="initialize">
    <template #modal-title>
      <div id="title" class="fw-bold">Available Promo Codes</div>
      <div id="subtitle">Copy a promo code and enter it in the previous screen</div>
    </template>
    <b-list-group ref="listGroup" flush style="max-height: 500px">
      <template v-if="items.length">
        <b-list-group-item v-for="(item, i) in items" :key="i" class="border-0">
          <div class="border-bottom pb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <TagIcon /><span class="fw-bold ml-2">{{ item.code }}</span>
              </div>
              <b-button variant="link" @click="copyPromoCode(item.code)" class="d-none">
                <CopyIcon />
              </b-button>
            </div>
            <div v-if="item.terms_and_conditions">
              <b-button pill variant="link" class="text-muted text-decoration-none px-0" v-b-toggle="`collapse-${i}`"
                size="sm">
                <span v-if="items[i].visible">
                  Hide Terms and Conditions <i class="bi bi-chevron-up" aria-hidden="true"></i>
                </span>
                <span v-else>
                  View Terms and Conditions <i class="bi bi-chevron-down" aria-hidden="true"></i>
                </span>
              </b-button>
              <b-collapse :id="`collapse-${i}`" class="text-left" v-model="items[i].visible">
                <div class="terms-and-conditions">
                  <p>
                    {{ item.terms_and_conditions }}
                  </p>
                </div>
              </b-collapse>
            </div>
          </div>
        </b-list-group-item>
      </template>
      <b-list-group-item v-else class="text-center">
        <JumpingDotsLoader v-if="loading" :fill="webDesign.design.main_color" />
        <div v-else >There are no Promo Codes available.</div>
      </b-list-group-item>
      <div v-observe-visibility="items.length ? reachedEndOfList : false" />
    </b-list-group>
    <template #modal-footer>
      <b-button pill id="back-button" class="w-75" @click="showDiscountModal">
        Back
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import TagIcon from "@/components/icons/TagIcon";
import CopyIcon from "@/components/icons/CopyIcon";
import JumpingDotsLoader from "@/components/common/JumpingDotsLoader";

export default {
  components: {
    TagIcon,
    CopyIcon,
    JumpingDotsLoader
  },
  data() {
    return {
      items: [],
      page: 1
    };
  },
  computed: {
    ...mapState("auth", ["token"]),
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("estore", ["cart", "loading", "availableCodes", "webDesign"])
  },
  watch: {
    availableCodes() {
      if (!this.availableCodes) {
        this.items = [];
        return;
      }

      const items = [];

      this.availableCodes.data.forEach(element => {
        items.push({
          ...element,
          visible: false
        });
      });

      this.items = _.uniqBy([...this.items, ...items], "code");
    }
  },
  methods: {
    ...mapActions("estore", ["getAvailableCodes"]),
    copyPromoCode(value) {
      this.$copyText(value, this.$refs.listGroup);
    },
    initialize() {
      this.items = [];
      this.page = 1;
      this.fetch();
    },
    showDiscountModal() {
      this.$bvModal.show("discount-modal");
      this.$bvModal.hide("view-available-codes-modal");
    },
    reachedEndOfList: _.debounce(function (reached) {
      if (reached) {
        if (this.page < this.availableCodes.max_page) this.page++;

        this.fetch();
      }
    }, 500),
    fetch() {
      const categoryIds = this.cart.list
        .map(list => {
          return list.items
            .map(i => {
              return i.product_inventory.product_details.category_id;
            })
            .flat();
        })
        .flat();

      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          branch_uuids: this.cart.list.map(e => e.branch_uuid),
          platform: "web",
          category_ids: categoryIds
        },
        page: this.page
      };

      this.getAvailableCodes(request);
    }
  }
};
</script>

<style lang="scss" scoped>
#view-available-codes-modal {
  #back-button {
    height: 50px;
    background-color: var(--main-color);
  }

  #title {
    font-size: 18px;
    color: #383E49;
  }

  #subtitle {
    font-size: 14px;
    color: #383E49;
  }

  .terms-and-conditions {
    position: relative;
    height: 150px;
    overflow-y: scroll;
    margin-top: 15px;
    font-size: 14px;
  }
}
</style>
